import { useEffect, useRef } from 'react';
import { useNavigableSectionsContext } from '@/components/content/ProductDetails/context/NavigableSectionsContext';
import {
	NAVIGABLE_SECTION_CLASS_NAME,
	NAVIGABLE_SECTION_ID_ATTRIBUTE,
	NAVIGABLE_SECTION_IDS,
} from '@/components/content/ProductDetails/constants';

/**
 * Registers a page section as navigable once its DOM element is mounted.
 *
 * @param sectionId - The unique identifier for the navigable section.
 * @returns Props that should be spread onto the section's root element.
 */
export const useNavigableSection = ({ sectionId }: { sectionId: NAVIGABLE_SECTION_IDS }) => {
	const ref = useRef<HTMLDivElement | null>(null);
	const { setSectionIds } = useNavigableSectionsContext();

	useEffect(() => {
		if (!ref.current) return;

		setSectionIds((prev) => {
			if (prev.has(sectionId)) return prev;

			return new Set(prev).add(sectionId);
		});
	}, [sectionId, setSectionIds]);

	return {
		ref,
		className: NAVIGABLE_SECTION_CLASS_NAME,
		[NAVIGABLE_SECTION_ID_ATTRIBUTE]: sectionId,
	};
};

export { NAVIGABLE_SECTION_IDS };
